import React from 'react';

export interface ConfiguracionesIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ConfiguracionesIcon: React.FC<ConfiguracionesIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" clip-path="url(#a)"><path d="M12.334 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/><path d="M19.734 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-.65 3.264 2 2 0 0 1-2.18-.434l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1.08-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1h-.17a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.934 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.08a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 3.416 1.415 2 2 0 0 1-.586 1.415l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1h.17a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.333 0h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default ConfiguracionesIcon;
